import React,{useState,useEffect, useContext } from "react";
import { AppContext } from "../../AppContext";

import PoliticalContribJwColeForm from "./PoliticalContribJwColeForm";
import PoliticalContribDefaultForm from "./PoliticalContribDefaultForm";

const PoliticalFromContrib = (props)=>{
   
  const [appContext, setAppContext] = useContext(AppContext);
  const isJwCole = appContext.clientId === "jwcole"?true:false;
  
    return (
      <>
        {isJwCole && (
        <PoliticalContribJwColeForm
        editorMode={props.editorMode}
        data={props.data}
          validation={props.validation}
          handleChange = {props.handleChange}
          handleDateChange = {props.handleDateChange}
        />)}
        {!isJwCole && (
        <PoliticalContribDefaultForm
        editorMode={props.editorMode}
        data={props.data}
          validation={props.validation}
          handleChange = {props.handleChange}
          handleDateChange = {props.handleDateChange}
          
          officials={props.officials}
          officialAdd={props.officialAdd}
          officialRemove={props.officialRemove}
          officialChanged={props.officialChanged} 
        />)}



      </>

    )

};

export default PoliticalFromContrib;